import React from 'react';
import { PageTitle } from '../components/Headings';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem;
`;

const Message = styled.p`
  font-size: 1.4rem;
  margin: 2rem 0;
`;

const StyledLink = styled.a`
  color: ${({ theme }) => theme.colors.brand_blue};
  text-decoration: none;
  font-weight: bold;
  font-size: 1.4rem;

  &:hover {
    text-decoration: underline;
  }
`;

const InactiveUserPage: React.FC = () => {
  return (
    <Container>
      <PageTitle as="h1">Your account is currently disabled.</PageTitle>
      <Message>
        To regain access, please send us an email by{' '}
        <StyledLink
          href="mailto:_DL_DIV_EM_Tool@storaenso.com?subject=Access%20Request%20to%20Energy%20Monitoring%20Tool&body=Hello%20Support%20Team,%0D%0A%0D%0AI%20would%20like%20to%20request%20access%20to%20the%20Energy%20Monitoring%20Tool.%0D%0A%0D%0AThank%20you."
        >
          clicking here
        </StyledLink>
        .
      </Message>
    </Container>
  );
};

export default InactiveUserPage;
